import { render, staticRenderFns } from "./thirdSamList.vue?vue&type=template&id=b57d9ef2"
import script from "./thirdSamList.vue?vue&type=script&lang=js"
export * from "./thirdSamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57d9ef2')) {
      api.createRecord('b57d9ef2', component.options)
    } else {
      api.reload('b57d9ef2', component.options)
    }
    module.hot.accept("./thirdSamList.vue?vue&type=template&id=b57d9ef2", function () {
      api.rerender('b57d9ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/thirdSam/thirdSamList.vue"
export default component.exports